import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ModalBody from "../../components/modal/ModalBody";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalView from "../../components/modal/ModalView";
import WelcomeSamplesListView from "../../components/welcomeScreen/WelcomeSamplesListView";
import PubSubTopics from "../../constants/pubSubTopics";
import Dimensions from "../../constants/styles/dimensions";
import { uiStateOperations } from "../../modules/uiState";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import samples from "../../testInBrowser/samplesArray";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import { onOpenMurderOnTheOrientExpress } from "../../utils/licenseMessages";
import openSampleTimeline from "../../utils/openSampleTimeline";
import preprocessorQuery from "../../utils/preprocessorQuery";
import welcomeScreenSelectors from "../welcomeScreen/selectors";

class SampleModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.onExampleClick = this.onExampleClick.bind(this);
  }

  componentDidMount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.SAMPLE_OPENED
    });
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.props.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.SAMPLE_CLOSED
    });
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  onExampleClick(exampleName) {
    if (isNativeCommsInstalled()) {
      onOpenMurderOnTheOrientExpress(exampleName);

      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.WELCOME_OPEN_EXAMPLE_FILE,
        exampleName
      });
    } else {
      openSampleTimeline(exampleName);
    }
  }

  closeFile() {
    if (isNativeCommsInstalled()) {
      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.FILE_CLOSE_AND_DELETE
      });
    }
  }

  render() {
    let modalHeading = null;
    let modalFooter = null;
    let fixedHeight = null;
    const isReadonly = preprocessorQuery.isReadonly();

    // #!if iOS === true
// modalHeading = (
// <ModalHeading
// title="Examples"
// showBack={true}
// onBackClick={isReadonly ? this.closeFile : this.props.onCloseClick}
// />
// );
// fixedHeight = Dimensions.MODAL_MAX_HEIGHT;
    // #!endif

    return (
      <ModalView
        className="sampleModal"
        header={modalHeading}
        footer={modalFooter}
        fixedHeight={fixedHeight}
        onBackdropClick={this.props.onCloseClick}
      >
        <ModalBody>
          <WelcomeSamplesListView sampleList={this.props.exampleFiles} onSampleClick={this.onExampleClick} />
        </ModalBody>
      </ModalView>
    );
  }
}

SampleModal.propTypes = {
  exampleFiles: PropTypes.array.isRequired,
  onCloseClick: PropTypes.func.isRequired
};

const readonlyActions = {
  onCloseClick: uiStateOperations.hideSampleModal
};

const editingActions = {};

const mapStateToProps = state => {
  let exampleFiles = samples;
  if (isNativeCommsInstalled()) {
    exampleFiles = welcomeScreenSelectors.getSamplesForRightPanel(state.present);
  }
  return {
    exampleFiles
  };
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SampleModal);
